import React, { useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import Form from 'ui/Form/Form';
import Button from 'ui/Button/Button';
import { IAccount } from 'store/accounts.model';
import { AxiosStatus } from 'api/axiosConfig';
import FieldsLeveler from 'ui/structure/FieldsLeveler/FieldsLeveler';
import SubmitLeveler from 'ui/structure/SubmitLeveler/SubmitLeveler';
import { changeFieldValue, setFieldTouched } from 'utils/formMutators';
import { renderBulkTransferFieldsFrom } from '../EditScheduleTransferFIelds';
import { IFormValues } from '../ScheduledTransfers.model';


interface IProps {
  accounts: IAccount[];
}

const BulkAccounts = ({ accounts }: IProps) => {
  const [submitStatus, setSubmitStatus] = useState<AxiosStatus>(AxiosStatus.DEFAULT);
  const submitting = submitStatus === AxiosStatus.PENDING;

  const dateFilterChange = (name: string, value?: string | null | undefined) => {
    console.log(name, value);
  };

  const handleClearDateInput = (name: string, value?: string | null | undefined) => {
    console.log(name, value);
  };

  const onSubmit = (values: IFormValues) => {
    setSubmitStatus(AxiosStatus.SUCCESS);
    console.log(values);
  };

  return (
    <Form
      onSubmit={onSubmit}
      mutators={{ changeFieldValue, setFieldTouched }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <FieldsLeveler label="Transfer From" dividerBottom>
            {renderBulkTransferFieldsFrom(accounts, submitting, dateFilterChange, handleClearDateInput)}
          </FieldsLeveler>
          <SubmitLeveler>
            <Button type="submit" disabled={submitting} fullWidth>
              {submitting ? <CircularProgress size={20} color="inherit" /> : 'Make Transfer'}
            </Button>
          </SubmitLeveler>
        </form>
      )}
    />
  );
};

export default BulkAccounts;
